// extracted by mini-css-extract-plugin
module.exports = {"xsmall":"Icon_xsmall__TAVjR","small":"Icon_small__cOCc4","medium":"Icon_medium__zFMPY","large":"Icon_large__nA3Jw","xlarge":"Icon_xlarge__bzdly","inherit":"Icon_inherit__vAC2J"};